import { useState } from 'react';
import { useForm } from 'react-hook-form';
import AppModal from '../appModal.component';

const AIQRunModel = props => {
    const [show, setModalShow] = useState(props.open);
    const [loading, setLoading] = useState(false);
    const [reportType, setReportType] = useState('');

    const { register, handleSubmit } = useForm({
        defaultValues: {},
    });

    const RunAIQ = async data => {
        setLoading(true);
        props.reRunAiq(reportType, data.aiq_rerun_reason);
        setLoading(false);
    };

    const handleModalClose = () => {
        setModalShow(false);
        props.handleModalClose(false);
    };

    return (
        <AppModal
            size="md"
            show={show}
            onHide={handleModalClose}
            backdrop="static"
            modalTitle="Run AIQ">
            <form
                className="row g-2"
                onSubmit={handleSubmit(RunAIQ)}>
                <div>
                    <label htmlFor="kit_replace_method" className="starlabel">
                        Select report type
                    </label>
                </div>
                <div className="col-md-12">
                    <div className="form-check form-check-inline col-md-2">
                        <input
                            className="form-check-input"
                            type="radio"
                            id="new_report"
                            value="New"
                            onClick={e => {
                                setReportType('New');
                            }}
                            {...register('report_creation_type')}
                        />
                        <label className="form-check-label" htmlFor="new_report">
                            New
                        </label>
                    </div>
                    <div className="form-check form-check-inline col-md-2">
                        <input
                            className="form-check-input"
                            type="radio"
                            id="revised_report"
                            value="Revised"
                            onClick={e => {
                                setReportType('Revised');
                            }}
                            {...register('report_creation_type')}
                        />
                        <label
                            className="form-check-label"
                            htmlFor="revised_report">
                            Revised
                        </label>
                    </div>
                </div>
                {reportType === 'Revised' && (
                    <div className="col-md-12">
                        <label className='starlabel'>Reason for AIQ run</label>
                        <input
                            type="text"
                            className="form-control"
                            id="aiqRerunReason"
                            {...register('aiq_rerun_reason', {
                                required: true,
                            })}
                        />
                    </div>
                )}
                <div className="col-md-12">
                    <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}>
                        {loading && (
                            <span className="spinner-border spinner-border-sm"></span>
                        )}
                        Submit
                    </button>
                </div>
            </form>
        </AppModal>
    );
};

export default AIQRunModel;
